import React, { useState } from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube, FaSpinner } from 'react-icons/fa';

const Contatti = () => {
  // State for form fields
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  
  // State for form submission and validation
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  
  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  // Form validation
  const validateForm = () => {
    let tempErrors = {};
    let isValid = true;
    
    if (!formData.name.trim()) {
      tempErrors.name = "Il nome è obbligatorio";
      isValid = false;
    }
    
    if (!formData.email.trim()) {
      tempErrors.email = "L'email è obbligatoria";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = "Email non valida";
      isValid = false;
    }
    
    if (!formData.message.trim()) {
      tempErrors.message = "Il messaggio è obbligatorio";
      isValid = false;
    }
    
    setErrors(tempErrors);
    return isValid;
  };
  
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Reset any previous API errors
    setApiError(null);
    
    if (validateForm()) {
      try {
        setIsLoading(true);
        
        // Send the data to our backend API
        const response = await fetch('http://localhost:3001/api/send-email', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });
        
        const data = await response.json();
        
        if (!response.ok) {
          throw new Error(data.message || 'Si è verificato un errore durante l\'invio dell\'email');
        }
        
        console.log("Form data submitted successfully:", data);
        setIsSubmitted(true);
        
        // Reset form after successful submission
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      } catch (error) {
        console.error("Error submitting form:", error);
        setApiError(error.message || 'Si è verificato un errore durante l\'invio. Riprova più tardi.');
      } finally {
        setIsLoading(false);
      }
    }
  };
  
  return (
    <div className="bg-gray-50">
      {/* Header Section */}
      <div className="bg-accent text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">Contatti</h1>
          <p className="text-xl max-w-3xl">
            Siamo qui per aiutarti. Non esitare a contattarci per qualsiasi domanda, informazione o supporto di cui hai bisogno.
          </p>
        </div>
      </div>
      
      {/* Contact Information Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-lg shadow-md flex flex-col items-center text-center">
            <div className="bg-accent/10 p-4 rounded-full mb-4">
              <FaMapMarkerAlt className="text-accent text-3xl" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Indirizzo</h3>
            <p className="text-gray-600">
              Via Benevento 6<br />
              00161 ROMA<br />
              Ematologia, Dipartimento di Medicina Traslazionale e di Precisione,<br />
              Sapienza Università di Roma, AOU Policlinico Umberto I
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-lg shadow-md flex flex-col items-center text-center">
            <div className="bg-accent/10 p-4 rounded-full mb-4">
              <FaPhone className="text-accent text-3xl" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Telefono</h3>
            <p className="text-gray-600">
              +39 3295585666<br />
              Lun - Ven, 9:00 - 18:00
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-lg shadow-md flex flex-col items-center text-center">
            <div className="bg-accent/10 p-4 rounded-full mb-4">
              <FaEnvelope className="text-accent text-3xl" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Email</h3>
            <p className="text-gray-600">
              info@robinhoodroma.org<br />
              supporto@robinhoodroma.org
            </p>
          </div>
        </div>
      </div>
      
      {/* Contact Form Section */}
      <div className="bg-gray-100 py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="md:flex">
              <div className="md:w-1/2 bg-accent text-white p-8">
                <h2 className="text-3xl font-bold mb-4">Parlaci di te</h2>
                <p className="mb-6">
                  Compila il modulo e ti risponderemo al più presto. Il tuo messaggio è importante per noi.
                </p>
                <div className="mb-6">
                  <h4 className="text-xl font-semibold mb-2">Orari di apertura:</h4>
                  <p>Lunedì - Venerdì: 9:00 - 18:00</p>
                  <p>Sabato: 9:00 - 13:00</p>
                  <p>Domenica: Chiuso</p>
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-2">Seguici:</h4>
                  <div className="flex space-x-4">
                    <a href="#" className="text-white hover:text-accent/70">
                      <FaFacebook size={24} />
                    </a>
                    <a href="#" className="text-white hover:text-accent/70">
                      <FaTwitter size={24} />
                    </a>
                    <a href="#" className="text-white hover:text-accent/70">
                      <FaInstagram size={24} />
                    </a>
                    <a href="#" className="text-white hover:text-accent/70">
                      <FaLinkedin size={24} />
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="md:w-1/2 p-8">
                {isSubmitted ? (
                  <div className="bg-green-100 text-green-700 p-4 rounded-lg mb-4">
                    <h3 className="font-bold text-xl mb-2">Grazie per averci contattato!</h3>
                    <p>Abbiamo ricevuto il tuo messaggio e ti risponderemo al più presto.</p>
                  </div>
                ) : (
                  <>
                    {apiError && (
                      <div className="bg-accent/10 text-accent p-4 rounded-lg mb-4">
                        <h3 className="font-bold text-xl mb-2">Errore</h3>
                        <p>{apiError}</p>
                      </div>
                    )}
                  <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                      <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Nome e Cognome*</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent ${errors.name ? 'border-accent' : 'border-gray-300'}`}
                      />
                      {errors.name && <p className="text-accent text-sm mt-1">{errors.name}</p>}
                    </div>
                    
                    <div className="mb-4">
                      <label htmlFor="email" className="block text-gray-700 font-medium mb-2">Email*</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent ${errors.email ? 'border-accent' : 'border-gray-300'}`}
                      />
                      {errors.email && <p className="text-accent text-sm mt-1">{errors.email}</p>}
                    </div>
                    
                    <div className="mb-4">
                      <label htmlFor="phone" className="block text-gray-700 font-medium mb-2">Telefono</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent"
                      />
                    </div>
                    
                    <div className="mb-4">
                      <label htmlFor="subject" className="block text-gray-700 font-medium mb-2">Oggetto</label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent"
                      />
                    </div>
                    
                    <div className="mb-6">
                      <label htmlFor="message" className="block text-gray-700 font-medium mb-2">Messaggio*</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows="5"
                        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent ${errors.message ? 'border-accent' : 'border-gray-300'}`}
                      ></textarea>
                      {errors.message && <p className="text-accent text-sm mt-1">{errors.message}</p>}
                    </div>
                    
                    <button 
                      type="submit" 
                      disabled={isLoading}
                      className={`bg-accent text-white px-6 py-3 rounded-lg font-semibold hover:bg-accent/90 transition duration-300 flex items-center ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
                    >
                      {isLoading ? (
                        <>
                          <FaSpinner className="animate-spin mr-2" />
                          Invio in corso...
                        </>
                      ) : (
                        'Invia Messaggio'
                      )}
                    </button>
                  </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Office Locations Section */}
      <div className="container mx-auto px-4 py-16">
        <h2 className="text-3xl font-bold text-center mb-12">Le Nostre Sedi</h2>
        
        <div className="grid md:grid-cols-1">
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="bg-gray-300 flex items-center justify-center" style={{ height: '400px' }}>
              {/* Google Maps integration */}
              <div className="mapouter" style={{ position: 'relative', textAlign: 'right', width: '100%', height: '400px' }}>
                <div className="gmap_canvas" style={{ overflow: 'hidden', background: 'none!important', width: '100%', height: '400px' }}>
                  <iframe 
                    className="gmap_iframe" 
                    style={{ height: '400px' }} 
                    width="100%" 
                    frameBorder="0" 
                    scrolling="no" 
                    marginHeight="0" 
                    marginWidth="0" 
                    src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=Via Benevento 6 00161 ROMA&amp;t=k&amp;z=17&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="p-6">
              <h3 className="text-xl font-bold mb-2">Dove siamo</h3>
              <p className="text-gray-600 mb-4">
                Via Benevento 6, 00161 ROMA<br />
                Ematologia, Dipartimento di Medicina Traslazionale e di Precisione,<br />
                Sapienza Università di Roma, AOU Policlinico Umberto I<br />
                Tel: +39 3295585666<br />
                Email: sede.roma@robinhoodroma.org
              </p>
              <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent/90 font-medium">
                Indicazioni stradali →
              </a>
            </div>
          </div>
        </div>
      </div>
      
      {/* Social Media Section */}
      <div className="bg-accent text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-8">Seguici sui Social Media</h2>
          <div className="flex justify-center space-x-8 mb-10">
            <a href="#" className="bg-white text-accent hover:bg-accent/10 p-4 rounded-full transition duration-300">
              <FaFacebook size={32} />
            </a>
            <a href="#" className="bg-white text-accent hover:bg-accent/10 p-4 rounded-full transition duration-300">
              <FaTwitter size={32} />
            </a>
            <a href="#" className="bg-white text-accent hover:bg-accent/10 p-4 rounded-full transition duration-300">
              <FaInstagram size={32} />
            </a>
            <a href="#" className="bg-white text-accent hover:bg-accent/10 p-4 rounded-full transition duration-300">
              <FaLinkedin size={32} />
            </a>
            <a href="#" className="bg-white text-accent hover:bg-accent/10 p-4 rounded-full transition duration-300">
              <FaYoutube size={32} />
            </a>
          </div>
          <p className="text-xl">
            Resta aggiornato sulle nostre attività, eventi e storie di successo. Unisciti alla nostra community!
          </p>
          <div className="mt-8">
            <h3 className="text-2xl font-bold mb-4">Hashtag ufficiali</h3>
            <div className="flex flex-wrap justify-center gap-4">
              <span className="bg-accent/90 px-4 py-2 rounded-full text-lg">#RobinHoodRoma</span>
              <span className="bg-accent/90 px-4 py-2 rounded-full text-lg">#MalattieRare</span>
              <span className="bg-accent/90 px-4 py-2 rounded-full text-lg">#InsieméPiùForti</span>
              <span className="bg-accent/90 px-4 py-2 rounded-full text-lg">#SosteniamociInsieme</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contatti;
